import ReactDOM from 'react-dom'
import { error, success, warning } from '@react/react-spectrum/Toast/js/ToastContainer'

export function copyInputByRef(elementRef) {
  const element = ReactDOM.findDOMNode(elementRef.current)

  if (navigator?.clipboard) {
    navigator.clipboard.writeText(element.value || element.innerText)
    success('Value copied to clipboard.')
    return
  } else {
    try {
      element.select()
      element.setSelectionRange(0, 99999)
      document.execCommand('copy')
      success('Value copied to clipboard.')
    } catch (e) {
      warning('Your browser blocked copying. Select and copy this value manually.')
    }
  }
}

export function copyValue(val) {
  if (!navigator?.clipboard) {
    warning('Your browser blocked copy attempt.')
    return
  }

  try {
    navigator.clipboard.writeText(JSON.stringify(val))
    success('Value copied to clipboard.')
  } catch (err) {
    error('Copy attempt failed. Incorrect content type.')
  }
}

export async function readValue() {
  if (!navigator?.clipboard) {
    warning('Your browser blocked clipboard paste attempt.')
    return
  }

  try {
    const val = await navigator.clipboard.readText()
    return JSON.parse(val)
  } catch (err) {
    error('Paste attempt failed. Incorrect content type.')
    return null
  }
}
